import { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

class UserClassStoryPlanned extends Component {
  constructor(props) {
    super(props)
    this.cancelClass = this.cancelClass.bind(this)
  }

  cancelClass(e, event) {
    e.preventDefault()
    this.props.cancelEventParticipation(event)
  }

  render() {
    const { classes, cancelEventParticipation, t } = this.props
    return (
      <div className="ctp-userclass-planned">
        <ul>
          {classes.map((item) => {
            return (
              <li key={item.id} className="ctp-userclass-planned__wrapper">
                <strong>{item.name}</strong>
                <data>{moment(item.date).format('DD MMM YYYY')}</data>
                <data>{moment(item.date).format('H:mm')}</data>
                {cancelEventParticipation && (
                  <button className="button button-gray" onClick={(e) => this.cancelClass(e, item)}>
                    {t('common:actions.cancel')}
                  </button>
                )}
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

UserClassStoryPlanned.propTypes = {
  classes: PropTypes.array,
  cancelEventParticipation: PropTypes.func,
  t: PropTypes.func,
}

export default withTranslation(['common'])(UserClassStoryPlanned)
